import React from "react";

export default function Sections({title, sectionList, descList, back}) {
  return (
    <>
      <div className="bg-white">
        <div className="mx-auto max-w-7xl px-6 py-24 sm:pt-32 lg:px-8 lg:py-40">
          <div className="lg:grid lg:grid-cols-12 lg:gap-8">
            <div className="lg:col-span-5">
              <h2 className=" my-4 text-2xl font-bold leading-10 tracking-tight text-gray-900">
                {title}
              </h2>
              {/* <p className="my-4 text-base leading-7 text-gray-600">
                Can’t find the answer you’re looking for? Reach out to our{" "}
                <a
                  href="#"
                  className="font-semibold text-indigo-600 hover:text-indigo-500"
                >
                  customer support
                </a>{" "}
                team.
              </p> */}
              {descList.map((item) => (
                  <div key={item.title}>
                    <dt className="text-base font-semibold leading-7 text-gray-900">
                      {item.title}
                    </dt>
                    <dd className="mt-2 text-base leading-7 text-gray-600">
                      {item.content}
                    </dd>
                  </div>
                ))}
            </div>
            <div className="mt-10 lg:col-span-7 lg:mt-0">
              <dl className="space-y-10">
                {sectionList.map((item) => (
                  <div key={item.title}>
                    <dt className="text-base font-semibold leading-7 text-gray-900">
                      {item.title}
                    </dt>
                    <dd className="mt-2 text-base leading-7 text-gray-600">
                      {item.content}
                    </dd>
                  </div>
                ))}
              </dl>
            </div>
          </div>
          <button onClick={()=>{
            back(false)
          }} type="button" className="w-full flex items-center justify-center px-5 py-2 my-4 text-sm text-gray-700 transition-colors duration-200 bg-white border rounded-lg gap-x-2 sm:w-auto dark:hover:bg-gray-800 dark:bg-gray-900 hover:bg-gray-100 dark:text-gray-200 dark:border-gray-700">
    <svg className="w-5 h-5 rtl:rotate-180" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor">
        <path stroke-Linecap="round" strokeLinejoin="round" d="M6.75 15.75L3 12m0 0l3.75-3.75M3 12h18" />
    </svg>
    <span>Go back</span>
</button>
        </div>
      </div>
    </>
  );
}
